export const More = () => {
  return (
    <svg viewBox="0 0 14 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="12"
        cy="2"
        r="1.5"
        stroke="currentColor"
        fill="currentColor"
      />
      <circle cx="2" cy="2" r="1.5" stroke="currentColor" fill="currentColor" />
      <circle cx="7" cy="2" r="1.5" stroke="currentColor" fill="currentColor" />
    </svg>
  )
}
